module.exports = __webpack_public_path__ + "img/ophelie.be426beb.png";